import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./VerRespuestasModal.styles";
import { showToast } from "../../utils/toast";

const API = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
    Authorization: `Bearer ${sessionStorage.getItem("token")}`
});

const VerRespuestasModal = ({ visible, onClose, induccion }) => {
    const [empleados, setEmpleados] = useState([]);
    const [detalle, setDetalle] = useState(null);
    const [busqueda, setBusqueda] = useState("");
    const [comentarios, setComentarios] = useState({});
    const [modoComentario, setModoComentario] = useState(false);
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
    const [formularioSeleccionado, setFormularioSeleccionado] = useState(null);

    useEffect(() => {
        if (!visible || !induccion) return;

        const cargarRespuestas = async () => {
            try {
                // =====================================================
                // 1. OBTENER RESPUESTAS DE LA INDUCCIÓN
                // =====================================================
                const resRespuestas = await axios.get(
                    `${API}/respuestas-induccion/${induccion.idinduccion}/`,
                    {
                        headers: getAuthHeaders()
                    }
                );

                const respuestas = Array.isArray(resRespuestas.data)
                    ? resRespuestas.data
                    : [];

                // =====================================================
                // 2. OBTENER USUARIO ACTUAL
                // =====================================================
                const usuarioActual = JSON.parse(
                    sessionStorage.getItem("usuario")
                );

                const idRol = Number(
                    sessionStorage.getItem("idRol")
                );

                // =====================================================
                // 3. SI NO ES COORDINADOR
                // =====================================================
                if (idRol !== 1) {
                    const porEmpleado = {};

                    respuestas.forEach(item => {
                        if (!item.idempleado) return;

                        if (!porEmpleado[item.idempleado]) {
                            porEmpleado[item.idempleado] = {
                                idempleado: item.idempleado,
                                nombre: item.nombre,
                                formularios: []
                            };
                        }

                        const yaExiste =
                            porEmpleado[item.idempleado].formularios.some(
                                f =>
                                    f.idformulariorespuesta ===
                                    item.idformulariorespuesta
                            );

                        if (!yaExiste) {
                            porEmpleado[item.idempleado].formularios.push({
                                idformulariorespuesta:
                                    item.idformulariorespuesta,
                                titulo: item.formulario_titulo
                            });
                        }
                    });

                    setEmpleados(
                        Object.values(porEmpleado)
                    );

                    return;
                }

                // =====================================================
                // 4. OBTENER EQUIPOS Y EMPLEADOS
                // =====================================================
                const [resEmp, resEquipos] = await Promise.all([
                    axios.get(`${API}/empleados/`, {
                        headers: getAuthHeaders()
                    }),

                    axios.get(`${API}/equipos/`, {
                        headers: getAuthHeaders()
                    })
                ]);

                const empleadosData = Array.isArray(resEmp.data)
                    ? resEmp.data
                    : resEmp.data.results || [];

                const equiposData = Array.isArray(resEquipos.data)
                    ? resEquipos.data
                    : resEquipos.data.results || [];

                // =====================================================
                // 5. BUSCAR EL EQUIPO DEL COORDINADOR
                // =====================================================
                const miEquipo = equiposData.find(
                    equipo =>
                        Number(equipo.idcoordinador) ===
                        Number(usuarioActual?.idempleado)
                );

                // =====================================================
                // 6. SI NO TIENE EQUIPO
                // =====================================================
                if (!miEquipo) {
                    setEmpleados([]);
                    return;
                }

                // =====================================================
                // 7. OBTENER EMPLEADOS DEL EQUIPO
                // =====================================================
                const empleadosMiEquipo = empleadosData.filter(
                    empleado =>
                        empleado.estado !== false &&
                        Number(empleado.idequipo) ===
                        Number(miEquipo.idequipo)
                );

                const idsEmpleadosMiEquipo = new Set(
                    empleadosMiEquipo.map(
                        empleado =>
                            Number(
                                empleado.idempleado ??
                                empleado.id
                            )
                    )
                );

                // =====================================================
                // 8. FILTRAR RESPUESTAS
                // =====================================================
                const respuestasPermitidas = respuestas.filter(
                    respuesta =>
                        idsEmpleadosMiEquipo.has(
                            Number(respuesta.idempleado)
                        )
                );

                // =====================================================
                // 9. AGRUPAR POR EMPLEADO
                // =====================================================
                const porEmpleado = {};

                respuestasPermitidas.forEach(item => {
                    if (!item.idempleado) return;

                    if (!porEmpleado[item.idempleado]) {
                        porEmpleado[item.idempleado] = {
                            idempleado: item.idempleado,
                            nombre: item.nombre,
                            formularios: []
                        };
                    }

                    const yaExiste =
                        porEmpleado[item.idempleado].formularios.some(
                            f =>
                                f.idformulariorespuesta ===
                                item.idformulariorespuesta
                        );

                    if (!yaExiste) {
                        porEmpleado[item.idempleado].formularios.push({
                            idformulariorespuesta:
                                item.idformulariorespuesta,
                            titulo: item.formulario_titulo
                        });
                    }
                });

                setEmpleados(
                    Object.values(porEmpleado)
                );

            } catch (error) {
                console.error(
                    "Error cargando respuestas:",
                    error.response?.data || error
                );

                setEmpleados([]);

                showToast(
                    "Error al cargar las respuestas",
                    "error"
                );
            }
        };

        cargarRespuestas();

    }, [visible, induccion]);

    useEffect(() => {
        if (detalle && detalle.respuestas) {
            const comentariosIniciales = {};

            detalle.respuestas.forEach(r => {
                comentariosIniciales[r.idrespuesta] = r.comentario || "";
            });

            setComentarios(comentariosIniciales);
        }
    }, [detalle]);

    const guardarComentarios = () => {
        const payload = {
            respuestas: detalle.respuestas.map(r => ({
                idrespuesta: r.idrespuesta,
                comentario: comentarios[r.idrespuesta] || "",
                puntaje: 0
            }))
        };

        showToast("Guardando comentarios...", "info");

        axios.put(
            `${API}/formulario-respuestas/${detalle.idformulariorespuesta}/calificar/`,
            payload,
            { headers: getAuthHeaders() }
        )
            .then(() => {
                showToast("Comentarios guardados correctamente", "success");
                setModoComentario(false);

                setDetalle(prev => ({
                    ...prev,
                    respuestas: prev.respuestas.map(r => ({
                        ...r,
                        comentario: comentarios[r.idrespuesta] || ""
                    }))
                }));
            })
            .catch(() => {
                showToast("Error al guardar los comentarios", "error");
            });
    };

    const cargarDetalle = (id) => {
        axios.get(`${API}/detalle-respuesta/${id}/`, {
            headers: getAuthHeaders()
        })
            .then(res => setDetalle(res.data));
    };

    if (!visible) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>

                {/* BOTÓN CERRAR */}
                <button style={styles.closeIcon} onClick={onClose}>
                    ✕
                </button>

                <h3>Respuestas de Inducción</h3>

                <div style={styles.body}>

                    {!detalle ? (
                        <>
                            <h4>Trabajadores</h4>
                            <input
                                type="text"
                                placeholder="Buscar por nombre o apellido..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    marginBottom: "10px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc"
                                }}
                            />

                            {empleados.length === 0 ? (
                                <p>No hay respuestas</p>
                            ) : (
                                <div style={{
                                    maxHeight: empleados.length > 4 ? "260px" : "auto",
                                    overflowY: empleados.length > 4 ? "auto" : "visible"
                                }}>
                                    {empleados
                                        .filter(e => {
                                            const texto = busqueda.toLowerCase();
                                            const nombre = (e.nombre || "").toLowerCase();
                                            const apellido = (e.apellido || "").toLowerCase();
                                            return nombre.includes(texto) || apellido.includes(texto);
                                        })
                                        .map(e => {
                                            const formularios = e.formularios || [];

                                            return (
                                                <div
                                                    key={e.idempleado}
                                                    style={styles.card}
                                                    onClick={() => {
                                                        setEmpleadoSeleccionado(e);

                                                        if (formularios.length > 0) {
                                                            setFormularioSeleccionado(formularios[0]);
                                                            cargarDetalle(formularios[0].idformulariorespuesta);
                                                        }
                                                    }}
                                                >
                                                    <div style={{
                                                        fontWeight: 600,
                                                        fontSize: "15px"
                                                    }}>
                                                        {e.nombre}
                                                    </div>

                                                    <div style={{
                                                        color: "#777",
                                                        fontSize: "13px",
                                                        marginTop: 4
                                                    }}>
                                                        {formularios.length} formulario{formularios.length !== 1 ? "s" : ""}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <button
                                style={styles.backButton}
                                onClick={() => {
                                    setDetalle(null);
                                    setEmpleadoSeleccionado(null);
                                    setFormularioSeleccionado(null);
                                    setModoComentario(false);
                                }}
                            >
                                ← Volver
                            </button>

                            <button
                                onClick={() => setModoComentario(true)}
                                style={{
                                    background: "#fb8500",
                                    color: "#fff",
                                    border: "none",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    marginBottom: "10px"
                                }}
                            >
                                Agregar comentarios
                            </button>


                            <h4>{empleadoSeleccionado.nombre}</h4>
                            <select
                                value={formularioSeleccionado?.idformulariorespuesta || ""}
                                onChange={(e) => {
                                    const formulario =
                                        (empleadoSeleccionado.formularios || []).find(
                                            f => f.idformulariorespuesta === Number(e.target.value)
                                        );

                                    if (formulario) {
                                        setFormularioSeleccionado(formulario);
                                        cargarDetalle(formulario.idformulariorespuesta);
                                    }
                                }}
                                style={{
                                    width: "100%",
                                    padding: "10px 12px",
                                    marginBottom: "20px",
                                    borderRadius: "8px",
                                    border: "1px solid #d1d5db",
                                    background: "#fff",
                                    fontSize: "15px"
                                }}
                            >
                                {(empleadoSeleccionado?.formularios || []).map(f => (
                                    <option
                                        key={f.idformulariorespuesta}
                                        value={f.idformulariorespuesta}
                                    >
                                        {f.titulo || `Formulario #${f.idformulariorespuesta}`}
                                    </option>
                                ))}
                            </select>

                            {detalle.respuestas.map((r) => (
                                <div key={r.idrespuesta} style={{ marginBottom: "15px" }}>
                                    <div style={styles.pregunta}>
                                        {r.pregunta}
                                    </div>

                                    <div style={styles.respuesta}>
                                        {r.respuesta}
                                    </div>

                                    {modoComentario && (
                                        <textarea
                                            placeholder="Escribir comentario..."
                                            value={comentarios[r.idrespuesta] || ""}
                                            onChange={(e) =>
                                                setComentarios({
                                                    ...comentarios,
                                                    [r.idrespuesta]: e.target.value
                                                })
                                            }
                                            style={{
                                                width: "100%",
                                                marginTop: "5px",
                                                padding: "6px",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc"
                                            }}
                                        />
                                    )}

                                    {!modoComentario && r.comentario && (
                                        <div style={{
                                            marginTop: "5px",
                                            fontStyle: "italic",
                                            color: "#555"
                                        }}>
                                            OBSERVACIONES: {r.comentario}
                                        </div>
                                    )}
                                </div>
                            ))}

                            {modoComentario && (
                                <button
                                    onClick={guardarComentarios}
                                    style={{
                                        background: "#219ebc",
                                        color: "#fff",
                                        border: "none",
                                        padding: "8px",
                                        borderRadius: "6px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Guardar comentarios
                                </button>
                            )}
                        </>
                    )}

                </div>
            </div>
        </div>
    );
};

export default VerRespuestasModal;